"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UiThemeProvider = void 0;
exports.buildUiTheme = buildUiTheme;
exports.useUiTheme = useUiTheme;
var _react = require("react");
var _dark = require("../tokens/dark");
var _light = require("../tokens/light");
var _scales = require("../tokens/scales");
var _effects = require("../tokens/effects");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Theme contract for @pitbrain/ui components. Deliberately independent of
 * React Navigation (mobile) and MUI (web): each app passes its active mode
 * once and the shared components resolve every token from this context.
 */

function buildUiTheme(mode) {
  return {
    mode,
    palette: mode === 'dark' ? _dark.darkPalette : _light.lightPalette,
    spacing: _scales.spacing,
    radius: _scales.radius,
    fontSizes: _scales.fontSizes,
    elevations: _effects.elevations[mode],
    motion: _effects.motion,
    focusRing: _effects.focusRing[mode]
  };
}

// Default to dark (the primary product experience) so components render
// sensibly even without a provider, e.g. in isolated tests.
const UiThemeContext = /*#__PURE__*/(0, _react.createContext)(buildUiTheme('dark'));
const UiThemeProvider = ({
  mode,
  children
}) => {
  const theme = (0, _react.useMemo)(() => buildUiTheme(mode), [mode]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(UiThemeContext.Provider, {
    value: theme,
    children: children
  });
};
exports.UiThemeProvider = UiThemeProvider;
function useUiTheme() {
  return (0, _react.useContext)(UiThemeContext);
}